import { apiGet } from "../../helpers/apiHelper";

const operators = {
  "===": (a, b) => a === b,
  "!==": (a, b) => a !== b,
  ">": (a, b) => a > b,
  "<": (a, b) => a < b,
  ">=": (a, b) => a >= b,
  "<=": (a, b) => a <= b,
  includes: (a, b) => typeof a === "string" && a.includes(b),
};

let query_cache = {};
let reducer_cache = {};

var _ = require("lodash");

const base_config = {
  dm: null,
  query_cache: null,
  reducer: function (map, obj) {
    map.push({
      value: obj.id,
      label: obj.name,
    });
    return map;
  },
  reducer_cache: null,
};

async function GetOptionsPure(u_config) {
  //console.log("GetOptions Base", u_config);
  let config = _.merge(Object.assign({}, base_config), u_config);
  //console.log(u_config.cur_lang && !u_config.reducer);
  if (u_config.cur_lang && !u_config.reducer) {
    config.reducer = function (map, obj) {
      map.push({
        value: obj.id,
        label: obj.translations[config.cur_lang].name,
      });
      return map;
    };
  }
  // console.log("GetOptions", config)
  // check il result cache is required, otherwise generate on the fly
  if (config.reducer_cache) {
    // console.log("Reducer cache", reducer_cache[config.reducer_cache])
    return reducer_cache[config.reducer_cache] || (await DoReduceP(config));
  } else {
    return await DoReduceP(config);
  }
}

async function DoReduceP(config) {
  // calcola il risultato
  var query_result = await GetResultsP(config);
  let res = query_result.reduce(config.reducer, []);
  // se è necessario salvalo in cache
  if (config.reducer_cache) {
    reducer_cache[config.reducer_cache] = res;
  }
  // console.log("DoReduce", res)
  return res;
}

async function GetResultsP(config) {
  // verifica se sono richiesti i valori in cache, altrimenti richiedili on the fly
  if (config.query_cache) {
    return query_cache[config.query_cache] || (await GetJsonP(config));
  } else {
    return await GetJsonP(config);
  }
}

async function GetJsonP(config) {
  const res = await apiGet(config.api, config.params);
  let results = null;

  if (res.data.payload) {
    results = res.data.payload.Items;
  } else {
    results = res.data.Items;
  }

  if (config.query) {
    config.query.forEach((element) => {
      const key = element.field;
      const value = element.value;
      const operator = element.operator;

      const compare = operators[operator];

      if (compare) {
        results = results.filter((item) => compare(item[key], value));
      } else {
        console.warn(`Unsupported operator: ${operator}`);
      }
    });
  }

  return results;
}

export default GetOptionsPure;
